import type { BootstrapResponse, User } from "../types";
import { normalizeEmailInput } from "./validation";

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    credentials: "same-origin",
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...init?.headers
    }
  });

  const body =
    response.status === 204
      ? null
      : ((await response.json().catch(() => null)) as Record<string, unknown> | null);

  if (!response.ok) {
    throw new Error(String(body?.error ?? `request_failed_${response.status}`));
  }
  return body as T;
}

export const api = {
  bootstrap: () => request<BootstrapResponse>("/api/bootstrap"),
  setup: (
    payload: {
      wearer: { displayName: string; email: string; password: string };
      controller: { displayName: string; email: string; password: string };
    },
    setupToken = ""
  ) =>
    request<{ recoveryCodes: { wearer: string; controller: string } }>(
      "/api/setup",
      {
        method: "POST",
        headers: setupToken ? { "X-Setup-Token": setupToken } : {},
        body: JSON.stringify({
          wearer: {
            ...payload.wearer,
            email: normalizeEmailInput(payload.wearer.email)
          },
          controller: {
            ...payload.controller,
            email: normalizeEmailInput(payload.controller.email)
          }
        })
      }
    ),
  login: (email: string, password: string, remember = false) =>
    request<{ user: User }>("/api/auth/login", {
      method: "POST",
      body: JSON.stringify({
        email: normalizeEmailInput(email),
        password,
        remember
      })
    }),
  logout: () =>
    request<void>("/api/auth/logout", {
      method: "POST",
      body: "{}"
    }),
  recover: (payload: {
    email: string;
    recoveryCode: string;
    newPassword: string;
  }) =>
    request<{ nextRecoveryCode: string }>("/api/auth/recover", {
      method: "POST",
      body: JSON.stringify({
        ...payload,
        email: normalizeEmailInput(payload.email)
      })
    })
};
